export default "__VITE_ASSET__7e2b2cd2__"